<template>
  <div class="bgfff out_wrap pr">
    <div class="back_wrap">
      <el-button @click="$router.go(-1)"><i class="el-icon-arrow-left" />返回</el-button>
      <span class="fs16 bold ml20">退款</span>
    </div>
    <!-- <el-divider></el-divider> -->
    <div class="pdlr20 el-main mb20">
      <div class="collection_title bold">商户号退款商户号</div>
      <div class="mt20 mb35">
        <el-form ref="refundModal1" :model="form" label-suffix=":" class="payFormModal" label-width="110px" :rules="rules">
          <div class="flex_column">
            <div v-for="(mch_list, index) in form.mch_list" :key="mch_list.mch_id" class="mch-item mr30 mt10">
              <el-form-item :label="`${mch_list.type == 1 ? '微信' : '支付宝'}商户号${index + 1}`">{{ mch_list.mch_id }}</el-form-item>
              <el-form-item label="剩余金额">￥{{ mch_list.returnPrice }}</el-form-item>
              <el-form-item
                label="退款余额"
                :prop="'mch_list.' + index + '.price'"
                :rules="[{
                  required: true, message: '金额不能为空', trigger: 'blur'
                }, {validator: (rule, value, callback) => validatorFn(rule, value, callback, index), trigger: 'blur'}]"
              >
                <el-input v-model="mch_list.price" class="w150" @input="changeFn" />
              </el-form-item>
            </div>
          </div>
          <div class="collection_title bold mb20 mt20">平台方退款信息</div>
          <div class="plr100 flex_between ">
            <div> <span class="bold">退款总金额：</span> ￥{{ refundNum }}</div>
            <el-divider direction="vertical" />
            <div> <span class="bold">服务费率：</span> {{ refundDetail.rate }}%</div>
            <el-divider direction="vertical" />
            <div> <span class="bold">实际退款金额：</span> ￥{{ refundAll }}</div>
          </div>
          <div class="collection_title bold mb20 ">商户号退款账号</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收款人" prop="user">
                <el-input v-model="form.user" class="w200" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行" prop="bank">
                <el-input v-model="form.bank" class="w200" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mb15">
            <el-col :span="12">
              <el-form-item label="银行卡号" prop="bank_card">
                <el-input v-model="form.bank_card" class="w200" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="center">
      <el-button type="primary" @click="submitForm('refundModal1')">确 认 退 款</el-button>
    </div>
  </div>
</template>
<script>

import { withdrawalInfo, withdrawal } from '@/api/refund'
export default {
  data() {
    return {
      dialogVisible: false,
      copyList: [], // 比对原始数据备份
      form: {
        user: '',
        bank: '',
        bank_card: '',
        mch_list: []
      },
      refundDetail: {},
      rules: {
        user: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ],
        bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bank_card: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    refundAll() {
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      return this.toDecimal(this.add(this.mul(sum, this.refundDetail.rate / 100), sum))
    },
    refundNum() {
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      return sum
    }

  },
  watch: {
    refundDetail: {
      handler(val) {
        if (val && val.mch_list && val.mch_list.length) {
          val.mch_list.forEach(item => {
            this.form.mch_list.push({
              mch_id: item.mch_id,
              price: +item.prcie / 100,
              returnPrice: item.prcie
            })
            this.copyList.push({
              mch_id: item.mch_id,
              price: +item.prcie / 100
            })
          })
        }
      },
      deep: true
    }
  },
  created() {
    this.refundFn()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 退款详情
    async refundFn() {
      const res = await withdrawalInfo()
      if (res.code === 200) {
        this.refundDetail = res.data
        this.$nextTick(() => {
          this.form.mch_list.forEach(item => {
            item.returnPrice = item.price
          })
          console.log(this.form.mch_list)
        })
      }
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate()
      if (!valid) return
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      if (+sum <= 0) {
        this.$message.error('所有商户号退款金额之和必须大于零!')
        return
      }
      if (valid) {
        const res = await withdrawal(this.form)
        if (res.code === 200) {
          this.$message({ type: 'success', message: '退款申请提交成功!' })
          this.$router.go(-1)
          this.form.user = ''
          this.form.bank = ''
          this.form.bank_card = ''
          this.form.mch_list = []
        }
      }
    },
    changeFn(val) {
      this.form.recharge_price = val.replace(/[^\d\.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    validatorFn(rule, value, callback, index) {
      // if (+this.copyList[index].price === 0) {
      //   callback(new Error(`当前商户号没有可退余额`))
      // } else if (+value <= 0) {
      //   callback(new Error('退款金额必须大于0'))
      // } else if (+value > this.copyList[index].price) {
      //   callback(new Error(`金额不能比${this.copyList[index].price}大`))
      // } else {
      //   callback()
      // }
      if (+value > this.copyList[index].price) {
        callback(new Error(`金额不能比${this.copyList[index].price}大`))
      } else {
        callback()
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.back{
    width: 69px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    border: 1px solid #1890FF;
    color: #1890FF;
    font-size: 14px;
}
.flex_start{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.collection_title{
 width: 100%;
 height: 42px;
 line-height: 42px;
 background: #FAFAFA;
 padding-left: 22px;
 border-left: 4px solid #1890FF;
 font-size: 15px;
}
.plr100{
    padding: 20px 100px;
}
.line{
    width: 1px;
    height: 20px;
    background: #D8D8D8;
}
.mch-item{
  padding:  10px;
  margin-bottom: 10px;
  border: 1px solid #EDEDED;
  width: 340px;
//   &:last-child{
//     margin-bottom: 0;
//   }
}
.flex_column{
     flex-flow: row wrap;
    justify-content: flex-start;
    display: flex;
    padding: 0px 30px;
}
.pdlr20{
    padding: 0px 20px;
}
.color_red{
    color: #D10000;
}
.mr30{
  margin-right: 30px;
}
.posifix{
   position: fixed;
    left: 0;
    bottom: 50px;
  // padding-left: 200px;
  // padding-right: 20px;
  width: 100%;
  transform: translateZ(0)
}
::v-deep .flex_column .el-form-item{
  margin-bottom: 10px;
}
</style>
